import { gql } from "@apollo/client";


export const creaateCategory = gql`
mutation AddSupplierCategories($supplierId: ID!, $categories: [ID!]!) {
  addSupplierCategories(supplier_id: $supplierId, categories: $categories)
}
`;